/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ls_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort any list of lines alphabetically, numerically, or by length — with reverse and case-insensitive options.`)
};

const es_ls_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordena cualquier lista de líneas alfabética, numérica o por longitud, con opciones de inversión e insensibilidad a mayúsculas.`)
};

const de_ls_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortieren Sie jede Liste von Zeilen alphabetisch, numerisch oder nach Länge — mit Optionen zum Umkehren und zur Ignorierung der Groß-/Kleinschreibung.`)
};

const nl_ls_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorteer elke reeks regels alfabetisch, numeriek of op lengte — met omgekeerde en niet-hoofdlettergevoelige opties.`)
};

const fr_ls_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triez n'importe quelle liste de lignes alphabétiquement, numériquement ou par longueur — avec options d'inversion et insensible à la casse.`)
};

const it_ls_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordina qualsiasi elenco di righe alfabeticamente, numericamente o per lunghezza — con opzioni di inversione e senza distinzione tra maiuscole e minuscole.`)
};

const pt_br2_ls_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordene qualquer lista de linhas alfabética, numérica ou por comprimento — com opções de reversão e sem distinção de maiúsculas.`)
};

const pt_ls_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classifique qualquer lista de linhas alfabeticamente, numericamente, ou por comprimento — com opções de inversão e insensibilidade a maiúsculas/minúsculas.`)
};

const ja_ls_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行のリストをアルファベット順、数値順、または長さでソート——逆順と大文字小文字区別なしオプション付き。`)
};

const zh_ls_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按字母顺序、数字顺序或行长度对任意列表中的行排序——支持反向排序和不区分大小写选项。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ls_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ls_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ls_intro", locale)
	if (locale === "en") return en_ls_intro(inputs)
	if (locale === "es") return es_ls_intro(inputs)
	if (locale === "de") return de_ls_intro(inputs)
	if (locale === "nl") return nl_ls_intro(inputs)
	if (locale === "fr") return fr_ls_intro(inputs)
	if (locale === "it") return it_ls_intro(inputs)
	if (locale === "pt-BR") return pt_br2_ls_intro(inputs)
	if (locale === "pt") return pt_ls_intro(inputs)
	if (locale === "ja") return ja_ls_intro(inputs)
	return zh_ls_intro(inputs)
};